import { CreateMemberRequest, FlagMemberAsPaidRequest, VerifyMemberStatusRequest } from './external-registration.types';

import {
  API_HOST,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/external-registration`;

export const getFindActiveProgrammesRequest = (): [string, HttpGetOptions] => [getEndpoint(), getHttpGetOptions()];

export const getCreateMemberRequest = (data: CreateMemberRequest): [string, HttpPostOptions<CreateMemberRequest>] => [
  getEndpoint(),
  getHttpPostOptions(data)
];

export const getFlagMemberAsPaidRequest = (data: FlagMemberAsPaidRequest): [string, HttpPutOptions<undefined>] => [
  getEndpoint(),
  getHttpPutOptions(undefined, {
    memberExternalReference: data.memberExternalReference,
    programmeExternalReference: data.programmeExternalReference
  })
];

export const getVerifyMemberStatusRequest = (data: VerifyMemberStatusRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/members/${data.memberExternalReference}/verify-status`,
  getHttpGetOptions()
];
